import * as mapRepository from '$domain/model/map/map.respositoy'

export const getAddressFromLocation = (lat, lng) => {
  return mapRepository.getAddressFromLocation(lat, lng)
}



// WEBPACK FOOTER //
// ./src/services/map/browserAddress/browserAddress.service.ts